// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bb-grey-1 {\n  border-bottom: 1px solid #888;\n}", ""]);
// Exports
module.exports = exports;
